import good1 from "../../assets/video/reactions/correct/goed_1.webm";
import good2 from "../../assets/video/reactions/correct/goed_2.webm";
import good3 from "../../assets/video/reactions/correct/goed_3.webm";
import good4 from "../../assets/video/reactions/correct/goed_4.webm";
import wrong1 from "../../assets/video/reactions/incorrect/nope_1.webm";
import wrong2 from "../../assets/video/reactions/incorrect/nope_2.webm";
import wrong3 from "../../assets/video/reactions/incorrect/nope_3.webm";
import wrong4 from "../../assets/video/reactions/incorrect/nope_4.webm";

const correct = [good1, good2, good3, good4];
const incorrect = [wrong1, wrong2, wrong3, wrong4];

const getVideo = (isCorrect: boolean): string =>
  isCorrect
    ? correct[Math.floor(Math.random() * correct.length)]
    : incorrect[Math.floor(Math.random() * incorrect.length)];

export default getVideo;
